
import { Loader2 } from 'lucide-react';

export const Loader = ({ size = 'default' }: { size?: 'small' | 'default' | 'large' }) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    default: 'w-8 h-8',
    large: 'w-12 h-12'
  };
  
  return (
    <div className="flex items-center justify-center p-4 w-full">
      <Loader2 className={`animate-spin text-youtube-red ${sizeClasses[size]}`} />
    </div>
  );
};

export default Loader;
